import { css, styled } from 'styled-components'
import { m } from 'motion/react'
import { type DiscountProgressVariant } from './discountProgress.consts'

export const BarRow = styled.div<{ $variant: DiscountProgressVariant }>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 25px;
  gap: 3px;

  /* Chip and Track read these variables, defaulting to the tinted pill's palette. */
  ${({ $variant, theme }) =>
    $variant === 'white' &&
    css`
      --discount-track-color: ${theme.colors.grayAccent};
      --discount-marker-bg: ${theme.colors.grayAccent};
      --discount-marker-halo: ${theme.colors.white};
      --discount-marker-border: ${theme.colors.white};
    `}
`

// The visible track: full width and static.
export const Track = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 3px;
  border-radius: 3px;
  background-color: var(
    --discount-track-color,
    ${({ theme }) => theme.colors.grayMidDark}
  );
  z-index: 0;
`

// Invisible flex spacer (order 1) between achieved and upcoming markers. Its
// right edge — measured in the component — is how far the fill may reach.
export const FillCap = styled.div`
  order: 1;
  flex: 1;
  height: 1px;
  min-width: 0;
`

// Spans the left edge up to the cap. Sized in px by plain style so measurement
// changes (mount, resize, font load) snap; the Fill inside animates in
// percentages of it.
export const FillTrack = styled.div`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 3px;
  z-index: 1;
`

// The pink fill, filling the FillTrack from the left.
export const Fill = styled(m.div)`
  height: 100%;
  border-radius: 3px;
  background-color: ${({ theme }) => theme.colors.primary};
`
